export default __webpack_public_path__ + "static/te_small-image_1-d7d43a5da86a96ea6cfcd03cab9c9cb9.png";